<div class="public-not-found">
  <div class="public-not-found__card">
    <a class="public-not-found__brand" [routerLink]="homeCommands()">
      <img
        src="/assets/images/logos/logo.svg"
        width="140"
        alt="Milinco"
        class="public-not-found__logo"
      />
    </a>

    <p class="public-not-found__code" aria-hidden="true">404</p>
    <h1 class="public-not-found__title">{{ 'auth.errorPage.title' | translate }}</h1>
    <p class="public-not-found__body">{{ 'auth.errorPage.body' | translate }}</p>

    <a mat-flat-button color="primary" class="public-not-found__cta" [routerLink]="homeCommands()">
      {{ 'auth.errorPage.backCta' | translate }}
    </a>
  </div>
</div>
